<template>
    <div>
        <!-- 过滤条件 -->
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 4px"
        >
            <form-lookup
                style="min-width: 262px; margin-right: 15px"
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room />
            </form-lookup>
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 高级搜索 -->
            <tenant-adv-search
                ref="adv"
                v-model="advFilter"
                :name="accessName"
                @confirm="onAdvConfirm"
            ></tenant-adv-search>
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 4px"
            @close="onAdvItemClose"
        ></select-tags>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusName"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            border
            ><template v-slot:cusName="{ row }">
                <Icon
                    custom=" iconfont iconfont-weixin"
                    size="24"
                    style="color: #46bb36"
                    v-if="row.wxUserId"
                />
                <Icon
                    custom=" iconfont iconfont-weixin"
                    size="24"
                    style="color: #dddddd"
                    v-else
                />
                {{ row.cusName }}
                <div>
                    <Button
                        v-if="row.wxUserId && $can('update')"
                        type="default"
                        size="small"
                        style="margin: 5px 0px"
                        @click="rowClickUnBind(row)"
                    >
                        解除绑定
                    </Button>
                    <Button
                        v-if="!row.wxUserId && $can('update')"
                        type="default"
                        size="small"
                        style="margin: 5px 0px"
                        @click="rowClickToBind(row)"
                    >
                        邀请绑定
                    </Button>
                </div>
            </template>
            <template v-slot:liveStatusText="{ row }">
                <tag-status
                    :text="row.liveStatusText"
                    :color="row.liveStatusColor"
                    :background="row.liveStatusBgc"
                    circle
                />
            </template>

            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="reminderRecord(row)"
                >
                    提醒记录
                </Button>
                <Dropdown
                    transfer
                    @on-click="
                        (name) => {
                            changeAction(name, row)
                        }
                    "
                >
                    <Button type="default" size="small">更多</Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="contractView" v-if="$can('view')">
                            查看合同
                        </DropdownItem>
                        <DropdownItem name="billView" v-if="$can('view')">
                            查看账单
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 提示信息——解除绑定 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowUnBind"
            :id="curId"
            @closeModal="closeModalUnBind"
            @confirmModal="confirmModalUnBind"
        />
        <!-- 弹出层——生成二维码 -->
        <create-qrcode
            v-model="modal.showCreateQrcode"
            @input="closeCreateQrcode"
            :id="user.cusId"
            :cusName="user.cusName"
            :houseName="user.houseName"
        />
        <!-- 弹出层——提醒记录 -->
        <smart-modal
            v-model="modal.showRemindRecordForm"
            title="提醒记录"
            :width="900"
            :height="600"
            :maskClosable="false"
            :buttons="[{ type: 'default', text: '关闭', name: 'cancel' }]"
        >
            <remind-record-form
                v-if="modal.showRemindRecordForm"
                :cusId="curId"
                :houseId="houseId"
                :cusName="cusName"
                :cusMobile="cusMobile"
                :houseName="houseName"
                :totalPeriod="totalPeriod"
            />
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { currency, ymdL, groupBy } from '_u/helper'
import Dict from '_u/dict'
import { pipeCell } from '@/components/grid/renderCell'

import mTenantList from '_v/common/m-tenant-list'
import SelectRoom from '_vc/select-room'
import TagStatus from '_vc/tag-status'
import Confirm from '_v/components/confirm'
import CreateQrcode from './create-qrcode'
import RemindRecordForm from './remind-record-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { tenantsList, tenantsUnBind } from '@/api/tenants'

export default {
    name: 't-history-list',
    mixins: [mTenantList],
    components: {
        SelectRoom,
        TagStatus,
        Confirm,
        CreateQrcode,
        RemindRecordForm,
        FilterDateRange,
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            curId: '',
            houseId: '',
            cusName: '',
            cusMobile: '',
            houseName: '',
            totalPeriod: '',
            user: {},
            page: {
                total: 0,
                list: [],
            },
            modalMsg: '',
            confirmShowUnBind: false,
            modal: {
                showCreateQrcode: false,
                showRemindRecordForm: false,
            },

            dict: {
                liveStatus: Dict.NULL,
            },
            contractStatusList: [],
        }
    },
    computed: {
        ...mapCache({
            filter: 'historyFilter',
            advFilter: 'historyAdvFilter',
            advOptions: 'historyAdvOptions',
            selectRoom: 'historySelectRoom',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 70,
                },

                {
                    key: 'cusName',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 150,
                    slot: 'cusName',
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'left',
                    minWidth: 160,
                    tooltip: true,
                },
                {
                    key: 'liveStatusText',
                    title: '居住状态',
                    align: 'center',
                    width: 120,
                    slot: 'liveStatusText',
                },
                {
                    key: 'rent',
                    title: '租金(元/月)',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    key: 'moveTime',
                    title: '搬离/作废时间',
                    align: 'center',
                    minWidth: 170,
                    render: pipeCell('ymdL'),
                },

                {
                    title: '操作',
                    align: 'center',
                    width: 160,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                tenantsList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
                Dict.get(['live_status']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    const liveStatusDict = this.dict.liveStatus
                    view.data.page.list.forEach((v) => {
                        v.rent = currency(v.rent / 100)
                        v.updateTime = ymdL(v.updateTime)

                        const status = liveStatusDict.get(v.liveStatus)
                        if (status) {
                            status.remark = JSON.parse(status.remark)
                            v.liveStatusText = status.text
                            v.liveStatusColor = status.remark.color
                            v.liveStatusBgc = status.remark.background
                        } else {
                            v.liveStatusText = ''
                        }
                    })
                    this.setPageData(view.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        setPageData(data) {
            data.page.list.forEach((v) => {
                v.groupByText = v.cusId + v.cusName
            })
            var list = []
            Object.values(groupBy(data.page.list, 'groupByText')).forEach(
                (g) => {
                    var first = g[0]

                    first._merge = {
                        cusName: {
                            rowspan: g.length,
                        },
                        cusMobile: {
                            rowspan: g.length,
                        },
                    }

                    list.push(...g)
                }
            )
            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },
        // 导出Excel
        onClickExport() {
            this.$refs.mt.exportToExcel()
        },
        // 解除绑定
        rowClickUnBind(row) {
            this.modalMsg = '解除绑定后租客将无法查看账单，是否确定？'
            this.confirmShowUnBind = true
            this.curId = row.cusId
        },
        closeModalUnBind() {
            this.confirmShowUnBind = false
        },
        confirmModalUnBind(id) {
            tenantsUnBind(id)
                .then(() => {
                    this.$Message.success('解除绑定成功')
                })
                .catch(() => {
                    this.$Message.error('解除绑定失败')
                })
                .finally(() => {
                    this.confirmShowUnBind = false
                    this.fetch()
                })
        },
        // 邀请绑定
        rowClickToBind(row) {
            this.user = row
            this.modal.showCreateQrcode = true
        },
        closeCreateQrcode() {
            this.modal.showCreateQrcode = false
        },
        // 更多
        changeAction(name, row) {
            console.log(name, row)
            this[name](row)
        },
        // 提醒记录
        reminderRecord(row) {
            this.curId = row.cusId
            this.houseId = row.houseId
            this.cusName = row.cusName
            this.cusMobile = row.cusMobile
            this.houseName = row.houseName
            this.totalPeriod = row.totalPeriod
            this.modal.showRemindRecordForm = true
        },
        // 查看合同
        contractView(row) {
            console.log('查看合同')
            this.$router.push({
                name: 'contractViewIndex',
                query: { contractId: row.contractId, type: '5' },
            })
        },
        // 查看账单
        billView(row) {
            console.log('查看账单')
            this.$router.push({
                name: 'contractViewIndex',
                query: {
                    contractId: row.contractId,
                    type: '5',
                    tabItem: 'contractViewBill',
                },
            })
        },
    },
}
</script>
<style lang="less" scoped></style>
